import { render, staticRenderFns } from "./UpdateDeleteTaxonomyTable.vue?vue&type=template&id=1fb586d4&"
import script from "./UpdateDeleteTaxonomyTable.vue?vue&type=script&lang=js&"
export * from "./UpdateDeleteTaxonomyTable.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports